// extracted by mini-css-extract-plugin
export default {"popupContainer":"detail_popupContainer__ts7f2","messageContainer":"detail_messageContainer__ZTeJU"};